import { cn } from "@/lib/utils"

const STATES = {
  online: {
    dot: "bg-primary shadow-[0_0_8px_var(--color-primary)]",
    text: "text-primary",
    label: "SYS.ONLINE",
  },
  standby: {
    dot: "bg-muted-foreground",
    text: "text-muted-foreground",
    label: "SYS.STANDBY",
  },
}

export function StatusPill({ state = "standby" }) {
  const variant = STATES[state] ?? STATES.standby
  return (
    <div className="hidden items-center gap-2 rounded-full border border-border bg-background px-3 py-1.5 font-mono text-xs sm:flex">
      <span className={cn("h-2 w-2 rounded-full", variant.dot)} />
      <span className={variant.text}>{variant.label}</span>
    </div>
  )
}
